export default __webpack_public_path__ + "static/media/Group-rows.cbde088d.svg";